export default __webpack_public_path__ + "static/media/kumosecretcornerbg.bd3a1b4d.webp";